import {Component, OnInit} from '@angular/core';
import {ApiAccessService} from '../../services/network/api-access.service';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';

@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.css']
})
export class LogOutComponent implements OnInit {
  constructor(private realtorPortalService: RealtorPortalService) {}

  ngOnInit() {
    ApiAccessService.clearLoginInfo();
    this.realtorPortalService.clearSideBarInfo();
  }
}
